import { useTranslation } from 'react-i18next';
import { Button } from './ui/Button';

export function LanguageSwitch() {
  const { i18n } = useTranslation();
  const next = i18n.resolvedLanguage === 'ru' ? 'en' : 'ru';

  return (
    <Button
      variant="ghost"
      onClick={() => {
        void i18n.changeLanguage(next);
      }}
      aria-label="Switch language"
    >
      {i18n.resolvedLanguage === 'ru' ? 'RU' : 'EN'}
    </Button>
  );
}
